module.exports = __webpack_public_path__ + "static/media/33-4.c5e0edd4.mp3";